import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import VillaTierra from "../pages/villa-tierra/page";
import VillaFuego from "../pages/villa-fuego/page";
import VillaAire from "../pages/villa-aire/page";
import VillaAgua from "../pages/villa-agua/page";
import VillaEter from "../pages/villa-eter/page";
import PrivacyPolicy from "../pages/privacy-policy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/villa-tierra",
    element: <VillaTierra />,
  },
  {
    path: "/villa-fuego",
    element: <VillaFuego />,
  },
  {
    path: "/villa-aire",
    element: <VillaAire />,
  },
  {
    path: "/villa-agua",
    element: <VillaAgua />,
  },
  {
    path: "/villa-eter",
    element: <VillaEter />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;